var React = require('react');

function DiamondGreen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M38.4052 0H7.59766L31.2312 19.5583L38.4052 0Z","fill":"#24CC85","key":0}),React.createElement("path",{"d":"M7.5963 0L0 12.6287L23.0001 42L31.2298 19.5583L7.5963 0Z","fill":"#D4F9EC","key":1}),React.createElement("path",{"d":"M38.4038 0L31.2298 19.5583L23 42L46.0001 12.6287L38.4038 0Z","fill":"#0E8F59","key":2})]);
}

DiamondGreen.defaultProps = {"viewBox":"0 0 46 42","fill":"none"};

module.exports = DiamondGreen;

DiamondGreen.default = DiamondGreen;
